// extracted by mini-css-extract-plugin
export var actionButton = "_7j-1";
export var actionButtons = "_7j-2";
export var actions = "_7j-0";
export var aiUnread = "_7j-10";
export var alignCenter = "_7j-h";
export var backWrapper = "_7j-3";
export var cellContainer = "_7j-4";
export var checkboxContainer = "_7j-5";
export var contentContainer = "_7j-6";
export var contentHeader = "_7j-8";
export var conversationsTableWrapper = "_7j-s";
export var draftReplyBadgeContainer = "_7j-m";
export var dropdownItem = "_7j-b";
export var dropdownItemsContainer = "_7j-a";
export var dropdownTitle = "_7j-c";
export var errorIcon = "_7j-7";
export var filter = "_7j-d";
export var gray = "_7j-i";
export var headerActionButtons = "_7j-e";
export var headerCheckboxContainer = "_7j-f";
export var icon = "_7j-j";
export var menuContainer = "_7j-k";
export var noMoreTicketsIcon = "_7j-12";
export var noMoreTicketsSubText = "_7j-13";
export var oneLine = "_7j-l";
export var optionsButton = "_7j-n";
export var plus = "_7j-o";
export var portalButtonsWrapper = "_7j-g";
export var red = "_7j-p";
export var scrolledTop = "_7j-9";
export var search = "_7j-q";
export var selectedConversationsCount = "_7j-r";
export var spinner = "_7j-t";
export var strong = "_7j-u";
export var summaryCell = "_7j-v";
export var tableContainer = "_7j-11";
export var tagContainer = "_7j-w";
export var threeDots = "_7j-x";
export var twoLines = "_7j-y";
export var unread = "_7j-z";